import styled from "styled-components";
import { color } from "@styles";
import { Arrow } from "components/atoms/svgs/Arrow";
import { mobile } from "components/templates/Breakpoints";

export const StyledAccordion = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledAccordionItem = styled.li`
  border: 2px solid ${color.S3100};
  border-radius: 8px;
  overflow: hidden;
`;

export const StyledAccordionTitle = styled.div`
  background: ${color.S3100};
  min-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 1.875rem;
  cursor: pointer;

  ${mobile} {
    padding: 0.5rem;
  }
`;

export const StyledAccordionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  cursor: pointer;
  text-align: left;
  @media (max-width: 300px) {
    font-size: 0.875rem;
  }
`;

export const Content = styled.div<{ isOpen: boolean }>`
  background: ${color.S310};
  padding: 1.5rem;
`;

export const StyledArrow = styled(Arrow)<{ isOpen: boolean }>`
  ${({ isOpen }) => isOpen && `transform: rotate(90deg);`}
  transition: transform 0.2s ease-in-out;
  margin-right: 1rem;
  flex-shrink: 0;
  cursor: pointer;
`;
